module.exports = __webpack_public_path__ + "./images/cd42dfe1d2eb0eb57c218fb759b6166c.webp";